import * as types from "./actionTypes";

export const getInfo = () => {
    return {
        type: types.GET_USER_INFO_REQUEST,
    }
};
export const getInfoSuccess = (data) => {
    return{
        type: types.GET_USER_INFO_SUCCESS,
        data: data
    }
};
export const getInfoFailure = (error) => {
    return{
        type: types.GET_USER_INFO_FAILURE,
        error: error
    }
};

export const updateInfo = (data) => {
    return {
        type: types.UPDATE_USER_INFO_REQUEST,
        data: data
    }
};
export const updateInfoSuccess = (data) => {
    return{
        type: types.UPDATE_USER_INFO_SUCCESS,
        data: data
    }
};
export const updateInfoFailure = () => {
    return{
        type: types.UPDATE_USER_INFO_FAILURE,
    }
};

export const changePassword = (data) =>{
    return{
        type: types.CHANGE_PASSWORD_REQUEST,
        data: data
    }
};
export const changePasswordSuccess = () =>{
    return{
        type: types.CHANGE_PASSWORD_SUCCESS,
    }
};
export const changePasswordFailure = () =>{
    return{
        type: types.CHANGE_PASSWORD_FAILURE,
    }
};